import React from 'react';
import {
  Row, Col, Form, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../utils/users';
import './DetailsEdit.scss';

const DetailsEdit = (props): JSX.Element => {
  const {
    initialValuesObject,
    edit,
  } = props;
  const getValorUnitario = (_initialValuesObject): any => {
    if (_initialValuesObject?.['GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO']) {
      return _initialValuesObject['GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO'].replaceAll('.', ',');
    }
    return '0,00';
  };
  const getValorTotal = (_initialValuesObject): any => {
    if (_initialValuesObject?.['GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL']) {
      return _initialValuesObject['GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL'].replaceAll('.', ',');
    }
    return '0,00';
  };
  const validatorTotUnit = (_rule: any, value): Promise<void> => {
    if (value < 0) {
      return Promise.reject(new Error('Deve ser um numero maior que zero'));
    }

    return Promise.resolve();
  };

  return (
    <div>
      {
        getUserType() === 'COOPERCITRUS'
          ? (
            <>
              <Row gutter={[24, 24]}>
                <Col xs={{ span: 24 }}>
                  <hr />
                  <p className="coletaTalhoesDetails__SessionTitle">Orçamento</p>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="zonaManejoDetails__FirstFieldRow"
              >
                <Col
                  xs={{ span: 24 }}
                  className="zonaManejoDetails__FirstFieldColumn"
                >
                  <Form.Item
                    className="vantDetails__DesiredSizeFormItem"
                    label={<span className="field-title-text">Valor unitário</span>}
                    name="GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO"
                    rules={[
                      {
                        validator: validatorTotUnit,
                      },
                    ]}
                    initialValue={getValorUnitario(initialValuesObject)}
                  >
                    <CurrencyInput
                      allowEmpty
                      className="ant-input"
                      decimalSeparator=","
                      thousandSeparator="."
                      placeholder="0,00"
                      step={0.01}
                      min={0}
                      disabled={edit}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="zonaManejoDetails__FirstFieldRow"
              >
                <Col
                  xs={{ span: 24 }}
                  className="zonaManejoDetails__FirstFieldColumn"
                >
                  <Form.Item
                    className="vantDetails__DesiredSizeFormItem"
                    label={<span className="field-title-text">Valor total</span>}
                    name="GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL"
                    rules={[
                      {
                        validator: validatorTotUnit,
                      },
                    ]}
                    initialValue={(getValorTotal(initialValuesObject))}
                  >
                    <CurrencyInput
                      allowEmpty
                      className="ant-input"
                      decimalSeparator=","
                      thousandSeparator="."
                      placeholder="0,00"
                      step={0.01}
                      min={0}
                      disabled={edit}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="zonaManejoDetails__FirstFieldRow"
              >
                <Col
                  xs={{ span: 24 }}
                  className="zonaManejoDetails__FirstFieldColumn"
                >
                  <Form.Item
                    className="vantDetails__DesiredSizeFormItem"
                    label={<span className="field-title-text">Condição de pagamento</span>}
                    name="GEOFERT-COLETA-POR-TALHOES-CONDICAO_PAGAMENTO"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-COLETA-POR-TALHOES-CONDICAO_PAGAMENTO']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength={255}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="zonaManejoDetails__FirstFieldRow"
              >
                <Col
                  xs={{ span: 24 }}
                  className="zonaManejoDetails__FirstFieldColumn"
                >
                  <Form.Item
                    className="vantDetails__DesiredSizeFormItem"
                    label={<span className="field-title-text">Forma de pagamento</span>}
                    name="GEOFERT-COLETA-POR-TALHOES-FORMA_PAGAMENTO"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-COLETA-POR-TALHOES-FORMA_PAGAMENTO']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength={255}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row
                gutter={[24, 24]}
                className="zonaManejoDetails__FirstFieldRow"
              >
                <Col
                  xs={{ span: 24 }}
                  className="zonaManejoDetails__FirstFieldColumn"
                >
                  <Form.Item
                    className="vantDetails__DesiredSizeFormItem"
                    label={<span className="field-title-text">Observações do orçamento</span>}
                    name="GEOFERT-COLETA-POR-TALHOES-OBSERVACOES"
                    rules={[
                      { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                    ]}
                    initialValue={initialValuesObject?.['GEOFERT-COLETA-POR-TALHOES-OBSERVACOES']}
                  >
                    <Input
                      style={{ width: '100%' }}
                      disabled={edit}
                      maxLength={255}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )
          : null
      }
    </div>
  );
};

DetailsEdit.propTypes = {
  initialValuesObject: PropTypes.shape({
    'GEOFERT-COLETA-POR-TALHOES-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-COLETA-POR-TALHOES-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-COLETA-POR-TALHOES-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-COLETA-POR-TALHOES-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-COLETA-POR-TALHOES-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
};

DetailsEdit.defaultProps = {};

export default DetailsEdit;
